(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1433],{

/***/ 44816:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bang-gia/kim-cuong/trang/[page]",
      function () {
        return __webpack_require__(97814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/ui/JsonLd/index.tsx
var JsonLd = __webpack_require__(59904);
// EXTERNAL MODULE: ./constants/business.ts
var business = __webpack_require__(56154);
// EXTERNAL MODULE: ./features/journal/components.tsx + 3 modules
var components = __webpack_require__(41046);
// EXTERNAL MODULE: ./features/journal/diamond-catalogue.ts
var diamond_catalogue = __webpack_require__(29233);
// EXTERNAL MODULE: ./features/journal/diamond-catalogue-view.tsx
var diamond_catalogue_view = __webpack_require__(9354);
// EXTERNAL MODULE: ./features/journal/diamond-config.ts
var diamond_config = __webpack_require__(55187);
// EXTERNAL MODULE: ./features/journal/market-pages.ts
var market_pages = __webpack_require__(71744);
// EXTERNAL MODULE: ./features/journal/price-tabs.tsx
var price_tabs = __webpack_require__(16609);
;// CONCATENATED MODULE: ./features/journal/diamond-catalogue-page.tsx












/** Paginated reference configurations retain their own crawlable catalogue URL. */ var DiamondCataloguePageLayout = function(param) {
    var catalogue = param.catalogue, usd = param.usd;
    var path = (0,diamond_catalogue/* diamondCataloguePath */.pq)(catalogue.page);
    var url = "".concat(business/* BUSINESS.appUrl */.aL.appUrl).concat(path);
    var inputs = catalogue.entries.map(function(param) {
        var profile = param.profile;
        return profile.input;
    });
    var weights = Array.from(new Set(inputs.map(function(input) {
        return input.carat;
    }))).sort(function(left, right) {
        return left - right;
    });
    var weight = weights.length ? "".concat(weights.map(diamond_catalogue_view/* diamondCarat */.w1).join(", "), " carat") : "";
    var shapes = Array.from(new Set(inputs.map(function(input) {
        var ref;
        return ((ref = diamond_config/* SHAPES.find */.HS.find(function(shape) {
            return shape.value === input.shape;
        })) === null || ref === void 0 ? void 0 : ref.name) || input.shape;
    }))).join(", ");
    var colors = Array.from(new Set(inputs.map(function(input) {
        return input.color;
    }))).sort().join(", ");
    var clarities = Array.from(new Set(inputs.map(function(input) {
        return input.clarity;
    }))).join(", ");
    var title = "Gi\xe1 kim cương ".concat(weight, " tham khảo – Trang ").concat(catalogue.page);
    var description = "".concat(catalogue.entries.length, " cấu h\xecnh kim cương ").concat(weight, " tham khảo – Trang ").concat(catalogue.page, ". D\xe1ng ").concat(shapes, ", m\xe0u ").concat(colors, ", độ tinh khiết ").concat(clarities, ". Xem gi\xe1 v\xe0 nguồn đối chiếu.");
    var crumbs = [
        {
            label: "Trang chủ",
            href: "/"
        },
        {
            label: "Bảng gi\xe1",
            href: market_pages/* MARKET_PAGES.overview.path */.x_.overview.path
        },
        {
            label: "Kim cương",
            href: market_pages/* MARKET_PAGES.diamond.path */.x_.diamond.path
        },
        {
            label: "Trang ".concat(catalogue.page)
        }, 
    ];
    var latestQuoteDate = catalogue.entries.flatMap(function(param) {
        var estimate = param.estimate;
        return estimate ? [
            estimate.updatedAt
        ] : [];
    }).sort().pop();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* JournalShell */.C2, {
        activeKey: "bang-gia",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: title,
                description: description,
                handle: path,
                image: "".concat(business/* BUSINESS.appUrl */.aL.appUrl, "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
                schema: [
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: crumbs.map(function(crumb, index) {
                            return {
                                "@type": "ListItem",
                                position: index + 1,
                                name: crumb.label,
                                item: "".concat(business/* BUSINESS.appUrl */.aL.appUrl).concat("href" in crumb && crumb.href ? crumb.href : path)
                            };
                        })
                    },
                    (0,_object_spread/* default */.Z)({
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "@id": "".concat(url, "#page"),
                        url: url,
                        name: title,
                        description: description,
                        inLanguage: "vi",
                        publisher: {
                            "@id": business/* BUSINESS.id */.aL.id
                        },
                        mainEntity: {
                            "@id": "".concat(url, "#reference-list")
                        }
                    }, latestQuoteDate ? {
                        dateModified: latestQuoteDate
                    } : {}), 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Breadcrumb */.aG, {
                items: crumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Section */.$0, {
                className: "!tw-pt-6 md:!tw-pt-8 !tw-pb-6 md:!tw-pb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Eyebrow */.j4, {
                        children: "AN THƯ \xb7 BẢNG GI\xc1 KIM CƯƠNG"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "tw-mt-3 tw-mb-0 tw-font-jr tw-text-[28px] md:tw-text-[44px] lg:tw-text-[48px] tw-font-normal tw-leading-[1.15]",
                        children: [
                            title,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-mt-3 tw-mb-0 tw-max-w-[820px] tw-text-[14px] md:tw-text-[17px] tw-leading-relaxed tw-text-jr-mute",
                        children: [
                            "Trang n\xe0y gồm ",
                            catalogue.entries.length,
                            " cấu h\xecnh d\xe1ng ",
                            shapes,
                            ", m\xe0u ",
                            colors,
                            ", độ tinh khiết ",
                            clarities,
                            ". Mở từng mục để xem đầy đủ th\xf4ng số, gi\xe1 ước t\xednh v\xe0 li\xean kết nguồn."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(price_tabs/* PriceTabs */.A, {
                active: "diamond"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(diamond_catalogue_view/* DiamondCatalogue */.ZS, {
                data: catalogue,
                usd: usd,
                standalone: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Section */.$0, {
                className: "!tw-pt-0 !tw-pb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-justify-between tw-gap-5 tw-rounded-lg tw-bg-jr-band tw-p-5 md:tw-p-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-m-0 tw-font-jr tw-text-[24px] tw-font-normal",
                                    children: "Bạn muốn xem th\xf4ng số kh\xe1c?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "tw-mt-2 tw-mb-0 tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                                    children: "Chọn carat, m\xe0u sắc v\xe0 độ tinh khiết trong c\xf4ng cụ tra cứu."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                            href: market_pages/* MARKET_PAGES.diamond.path */.x_.diamond.path,
                            className: "sm:tw-shrink-0",
                            children: "Mở c\xf4ng cụ tra cứu"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/bang-gia/kim-cuong/trang/[page]/index.tsx

var __N_SSP = true;
/* harmony default export */ var _page_ = (DiamondCataloguePageLayout);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2031,8276,4904,6874,9774,2888,179], function() { return __webpack_exec__(44816); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);